import { useState, useEffect } from "react";
import { getLiveByVishwasthaMandalType } from "../../network/lib/vishwasthaMandal.js";
import { getVishwasthaMandalTypes } from "../../network/lib/masterData.js";
import { showHideLoader } from "../utils/helper.js";

function VishwasthaMandal() {
  const [vishwasthaMandalDetails, setVishwasthaMandalDetails] = useState();
  const [vishwasthaMandalTypes, setVishwasthaMandalTypes] = useState();
  const [selectedValue, setSelectedValue] = useState("1");

  useEffect(() => {
    !vishwasthaMandalTypes && populateVishwasthaMandalTypes();
    !vishwasthaMandalDetails && populateVishwasthaMandalDetails(1);
  }, []);

  function populateVishwasthaMandalTypes() {
    getVishwasthaMandalTypes().then((res) => {
      if (res.status == 200) {
        setVishwasthaMandalTypes(res.data);
      }
    });
  }

  function populateVishwasthaMandalDetails(vishwasthaMandalType) {
    showHideLoader(true);

    getLiveByVishwasthaMandalType(vishwasthaMandalType).then((res) => {
      if (res.status == 200) {
        setVishwasthaMandalDetails(res.data);
        showHideLoader();
      }
    });
  }

  const types = vishwasthaMandalTypes && (
    <select
      onChange={(e) => {
        setSelectedValue(e.target.value);
        populateVishwasthaMandalDetails(e.target.value);
      }}
      value={selectedValue}
    >
      <option value="0">Select</option>
      {vishwasthaMandalTypes.map((x) => (
        <option key={x.id} value={x.id}>
          {x.name}
        </option>
      ))}
    </select>
  );

  const contents = vishwasthaMandalDetails && (
    <div style={{ textAlign: "left",  border: '3px solid #fe6902', borderRadius: '40px', padding:"10px 25px"}}>
      <div className="Row">
        <div className="Cell">
          <div className="Table">
            <div className="Row">
              <div className="Cell" style={{ fontWeight: 'bold' }}>विश्वस्त मंडळ प्रकार : </div>
              <div className="Cell">{types}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="Row"> 
        <div className="Cell">
          <div className="profile-main">
            {vishwasthaMandalDetails.map((vishwasthaMandalDetail) => (
              <div className="profile-listing">
                <div className="profile-image">
                  {selectedValue == "1" && vishwasthaMandalDetail.image && (
                    <img
                      id="img"
                      src={vishwasthaMandalDetail.image}
                      style={{ height: "80px", width: "80px",  }}
                    />
                  )}
                </div>
                <div>
                  <h2>{vishwasthaMandalDetail.name}</h2>
                  {vishwasthaMandalDetail.fromPeriod && (
                    <div className="profile-post">
                      <span>कालावधी: </span>
                      {vishwasthaMandalDetail.fromPeriod +
                        " - " +
                        vishwasthaMandalDetail.toPeriod}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return contents;
}

export default VishwasthaMandal;
